
export enum CollectionTreeViewMode {
    FLAT = "FLAT",
    FOLDERS = "FOLDERS",
}
